import React from "react";

/**
 * Multi-select from a list (roles, job titles): chosen values as chips plus
 * an "Add…" dropdown with the rest. options: [{ value, label }]
 */
const PickerChips = ({
  id,
  options,
  value,
  onChange,
  placeholder,
  emptyText,
  readOnly,
}) => {
  const labelOf = new Map(options.map((o) => [o.value, o.label]));
  const remaining = options.filter((o) => !value.includes(o.value));

  return (
    <div>
      <div className="chips-input chips-input--static">
        {value.length === 0 && (
          <span className="text-slate-400 fs-080">{emptyText}</span>
        )}
        {value.map((v) => (
          <span key={v} className="chip">
            {labelOf.get(v) || "Unknown"}
            {!readOnly && (
              <button
                type="button"
                className="chip-remove"
                onClick={() => onChange(value.filter((x) => x !== v))}
                aria-label={`Remove ${labelOf.get(v) || v}`}
              >
                <i className="bi bi-x"></i>
              </button>
            )}
          </span>
        ))}
      </div>
      {!readOnly && (
        <select
          id={id}
          className="form-select form-select-sm mt-2"
          value=""
          onChange={(e) =>
            e.target.value && onChange([...value, e.target.value])
          }
          disabled={remaining.length === 0}
        >
          <option value="">
            {remaining.length ? placeholder : "All added"}
          </option>
          {remaining.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default PickerChips;
